module.exports = __webpack_public_path__ + "img/il.7097038d.svg";